<template>
  <el-table-column
    prop="is_real"
    label="Valódi tömb"
    show-overflow-tooltip
    min-width="200"
    sortable="custom"
  >
    <template slot-scope="scope">
      {{ scope.row.is_real ? 'Igen' : 'Nem' }}
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'is_real',
  };
</script>
